import { useState } from 'react'

import type { Product } from '@subaio/api-types/service'
import { ButtonGroup, FormattedMessage } from '@subaio/components'

import type { OnLogEvent } from 'lib/container'

import type {
	Handlers,
	OpportunityCarInsuranceStep,
	OpportunityCarInsuranceStepType,
} from 'containers/OpportunityCarInsurance/handlers'

import { ButtonSolid, ButtonText } from 'components/Buttons'
import { Card } from 'components/Card'
import { Header } from 'components/Layout'
import { List, SelectableProductItem } from 'components/Lists'

import { Title } from '../Title'

type Props = TaggedType<OpportunityCarInsuranceStep, OpportunityCarInsuranceStepType.ProductList> & {
	onShowPersonalForm: Handlers['onShowPersonalForm']
	onShowProductNotListed: Handlers['onShowProductNotListed']
	onLogScopedEvent: OnLogEvent
	onStepBack?: () => void
}

export const ProductList = ({
	products,
	onShowPersonalForm,
	onShowProductNotListed,
	onLogScopedEvent,
	onStepBack,
}: Props) => {
	const [selectedProduct, setSelectedProduct] = useState<Product | null>(null)

	return (
		<Card>
			<Header>
				<Title>
					<FormattedMessage
						id='opportunityCarInsurance.productList.title'
						defaultMessage='Choose your current insurance'
					/>
				</Title>
			</Header>
			<List>
				{products.map((product, index) => (
					<SelectableProductItem
						key={product.id}
						product={product}
						isSelected={selectedProduct?.id === product.id}
						index={index}
						onSelect={() => setSelectedProduct(product)}
					/>
				))}
			</List>
			<ButtonGroup spacing={8} center column>
				<ButtonSolid
					label={<FormattedMessage id='opportunityCarInsurance.productList.buttonContinue' defaultMessage='Continue' />}
					disabled={!selectedProduct}
					onClick={() => onShowPersonalForm(selectedProduct!)}
				/>
				<ButtonText
					label={
						<FormattedMessage
							id='opportunityCarInsurance.productList.notListed'
							defaultMessage='My car insurance is not listed'
						/>
					}
					onClick={() => {
						onLogScopedEvent('PRODUCT_LIST_MISSING_INSURANCE')
						onShowProductNotListed()
					}}
				/>
				{onStepBack && (
					<ButtonText
						label={<FormattedMessage id='opportunityCarInsurance.buttonBack' defaultMessage='Back' />}
						onClick={() => onStepBack()}
					/>
				)}
			</ButtonGroup>
		</Card>
	)
}
